export const toPipelineSlug = (value: string): string =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

export const resolvePipelineSlug = (pipeline: { id: string; name: string }): string => {
  const slug = toPipelineSlug(pipeline.name);
  return slug.length > 0 ? slug : pipeline.id;
};
